import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Avatar } from "@/components/ui/avatar";
import { UserProfile } from "@/lib/types";

interface EditProfileViewProps {
  profile: UserProfile;
  onSave: () => void;
  onCancel: () => void;
  onChange: (field: keyof UserProfile, value: string) => void;
}

export const EditProfileView = ({ profile, onSave, onCancel, onChange }: EditProfileViewProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <Avatar className="w-16 h-16" />
        <div className="flex-1 space-y-2">
          <Input
            value={profile.username}
            onChange={(e) => onChange('username', e.target.value)}
            placeholder="Your name"
          />
          <Input
            value={profile.handle}
            onChange={(e) => onChange('handle', e.target.value)}
            placeholder="@handle"
          />
        </div>
      </div>
      <Textarea
        value={profile.bio}
        onChange={(e) => onChange('bio', e.target.value)}
        placeholder="Tell us about yourself"
        className="min-h-[100px]"
      />
      
      <div className="flex gap-2">
        <Button variant="outline" className="flex-1" onClick={onCancel}>
          Cancel
        </Button>
        <Button className="flex-1" onClick={onSave}>
          Save Changes
        </Button>
      </div>
    </div>
  );
};